<template>
    <b-container fluid class="mt--7">
        <b-card title="Bulk Reviews">
            <b-card-header>
                <b-row>
                    <b-col cols="8">
                        <b-form-group
                            id="fieldset-1"
                            label="Review Type:"
                            label-for="user-input"
                            label-cols="2"
                        >
                            <b-form-select
                                id="user-input"
                                v-model="checkoff_type_id"
                                :options="filteredTypes"
                                text-field="name"
                                value-field="id"
                                trim
                            >
                                <template #first>
                                    <b-form-select-option :value="null" disabled
                                        >-- Please Select a Type
                                        --</b-form-select-option
                                    >
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-button
                            :disabled="selectedOrders.length == 0"
                            variant="primary"
                            block
                            @click="doBulkAction"
                            >Submit</b-button
                        >
                    </b-col>
                </b-row>
            </b-card-header>
            <b-card-body>
                <b-table
                    id="orderTable"
                    striped
                    hover
                    :fields="fields"
                    :items="relevantOrders"
                    selectable
                    responsive
                    @row-selected="onRowSelected"
                    ref="orderTable"
                >
                    <template #head(id)>
                        <b-form-checkbox
                            v-if="orders.length > 0"
                            :checked="orders.length === selectedOrders.length"
                            @change="toggleAllRow()"
                        ></b-form-checkbox>
                    </template>

                    <template #cell(id)="{ rowSelected, index }">
                        <b-form-checkbox
                            :checked="rowSelected"
                            @change="toggleRow(index, rowSelected)"
                        ></b-form-checkbox>
                    </template>

                    <template #cell(custom)="{ item }">
                        <b-button
                            size="sm"
                            :to="`/admin/orders/${item.id}`"
                            class="mr-2"
                            variant="primary"
                            target="_blank"
                        >
                            View
                        </b-button>
                    </template>

                    <template #cell(return_quantity)="row">
                        <b-form-input
                            type="number"
                            v-model="row.item.return_quantity"
                            placeholder="Return Qty"
                        ></b-form-input>
                    </template>
                </b-table>
            </b-card-body>
        </b-card>
    </b-container>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
export default {
    mixins: [popupMixins],
    data: () => ({
        selectedOrders: [],
        checkoff_type_id: null,
        fields: [
            { key: 'id', label: '' },
            { key: 'custom', label: '' },
            'reference_no',
            'description',
            {
                key: 'customer',
                label: 'Customer',
                formatter: x => `${(x && x.name) || ''}`,
            },
            {
                key: 'driver',
                label: 'Officer',
                formatter: x =>
                    `${(x && x.first_name) || ''} ${(x && x.last_name) || ''}`,
            },
            {
                key: 'type',
                label: 'Type',
                formatter: x => x.name,
            },
        ],
    }),
    computed: {
        user() {
            const user = this.$store.state.user
            console.log('user', user)
            return user
        },
        checkoffTypes() {
            const types = this.$store.state.checkoffTypes.types
            console.log('types', types)
            return types
        },
        filteredTypes() {
            const _types = []
            console.log('user.roles', this.user.roles)
            for (let type of this.checkoffTypes) {
                for (let type_role of type.checkoff_type_roles) {
                    console.log('type_role', type_role)
                    if (
                        this.user.roles.some(
                            user_role => user_role.role_id === type_role.role_id
                        )
                    ) {
                        _types.push(type)
                    }
                }
            }
            return _types
        },
        orders() {
            return this.$store.state.orders.items
        },
        relevantOrders() {
            const { checkoff_type_id } = this
            return this.orders.filter(x => {
                if (!x.checkoff_template_id) return false
                console.log('x.checkoffs', x.checkoffs)
                const checkoffs = x.checkoffs || []
                const _selectedCheckoff = checkoffs.find(
                    x => x.checkoff_type_id == checkoff_type_id
                )
                console.log('_selectedCheckoff', _selectedCheckoff)
                if (checkoffs.length === 0) return false
                if (!_selectedCheckoff) return false
                if (_selectedCheckoff.completed == 1) return false
                if (_selectedCheckoff.sequence_no == 1) return true
                if (checkoffs.length === 1) return true
                return !checkoffs.some(
                    x =>
                        x.id != _selectedCheckoff.id &&
                        x.sequence_no < _selectedCheckoff.sequence_no &&
                        x.completed == 0
                )
            })
        },
    },
    watch: {
        checkoff_type_id: function (val) {
            this.fetchOrders(val)
        },
    },
    created() {
        this.$store.dispatch('checkoffTypes/fetchAll')
    },
    mounted() {
        console.log('mounted --user', this.user)
        this.fetchOrders()
    },
    methods: {
        onRowSelected(items) {
            this.selectedOrders = items
        },
        selectAllRows() {
            this.$refs.orderTable.selectAllRows()
        },
        clearSelected() {
            this.$refs.orderTable.clearSelected()
        },
        toggleRow(index, rowSelected) {
            // Rows are indexed from 0, so the third row is index 2
            if (rowSelected) this.$refs.orderTable.unselectRow(index)
            else this.$refs.orderTable.selectRow(index)
        },

        toggleAllRow() {
            if (this.orders.length === this.selectedOrders.length)
                this.$refs.orderTable.clearSelected()
            else this.$refs.orderTable.selectAllRows()
        },
        ///////////////////////////////
        fetchOrders(val = this.checkoff_type_id) {
            console.log(val)
            if (val) this.$store.dispatch('orders/selectCheckoffOrders', val)
            else {
                this.$store.commit('orders/SET_ORDERS', [])
            }
        },

        async doBulkAction() {
            // try {
            console.log('selectedOrders', this.selectedOrders)
            const title = 'Clear Action?'
            const message = `Are you sure you want to clear these orders?`
            const result = await this.confirmMessage(title, message)
            if (!result) throw new Error()

            const orders = this.selectedOrders.map(x => x.id)
            const { checkoff_type_id } = this
            console.log('orders--checkoff_type_id', checkoff_type_id)
            console.log('orders--tests', orders)
            await this.$store.dispatch('orders/bulkCheckoffOrders', {
                orders,
                checkoff_type_id,
            })
            this.doToast(
                'Success!',
                'Selected orders have been Cleared',
                'success'
            )
            this.clearSelected()
            this.fetchOrders()
            /*  } catch (err) {
                console.error('err', err)
                this.doToast('Error!', err.message, 'danger')
            } */
        },
    },
}
</script>